/**
 * Forgot Password
 * Author: Kyle Shearer
 */

var ForgotPassword = (function () {

    var options = {
        passwordForm: $('.js-forgot-password-form')
    };

    function canInit() {

        if (options.passwordForm.length) {
            return true;
        }

        return false;
    }

    function init(params) {
        options = $.extend({}, options, params);

        if (canInit()) {
            ForgotPassword();
            console.log('Forgot Password initialized');
        }
    }

	/**
     * Handle forgot password form
     */
    function ForgotPassword() {

        options.passwordForm.on('submit', function (e) {

            e.preventDefault();

            if (!Validation.validateForm(options.passwordForm)) {
                Eskimo.showError(options.passwordForm, "Please enter a username or email address");
                return false;
            }

            $.ajax({
                type: "POST",
                url: "/xhr/forgot-password.php",
                data: options.passwordForm.serialize(),
                success: function (response) {

                    try {
                        var jsonResponse = JSON.parse(response);

                        if (jsonResponse.success === true) {
                            Eskimo.showSuccess(options.passwordForm, jsonResponse.message);
                            Eskimo.resetForm(options.passwordForm);
                        } else {
                            Eskimo.showError(options.passwordForm, jsonResponse.message);
                        }
                    } catch (e) {
                        console.log(e);
                        Eskimo.showError(options.passwordForm, 'Sorry, there was an error processing your request.');
                    }
                }
            });

            return false;
        });
    }

    return {
        init: init
    };

})();

$(function () {
    'use strict';
    ForgotPassword.init();
});